var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNauru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 39.9999C31.0455 39.9999 39.9998 31.0456 39.9998 19.9999C39.9998 8.95418 31.0455 -0.00012207 19.9998 -0.00012207C8.95406 -0.00012207 -0.000244141 8.95418 -0.000244141 19.9999C-0.000244141 31.0456 8.95406 39.9999 19.9998 39.9999Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 39.9999C31.0455 39.9999 39.9998 31.0456 39.9998 19.9999C39.9998 8.95418 31.0455 -0.00012207 19.9998 -0.00012207C8.95406 -0.00012207 -0.000244141 8.95418 -0.000244141 19.9999C-0.000244141 31.0456 8.95406 39.9999 19.9998 39.9999Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0C9.54031 0 0.957656 8.02977 0.0761719 18.2609H39.9239C39.0423 8.02977 30.4597 0 20 0V0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C30.4597 40 39.0423 31.9702 39.9239 21.7391H0.0761719C0.957656 31.9702 9.54031 40 20 40Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5217 26.9565L14.2806 28.0107L15.4739 30.1811L13.0404 29.7155L12.7321 32.1739L11.037 30.3659L9.34198 32.1739L9.03362 29.7155L6.60002 30.181L7.79346 28.0106L5.55237 26.9565L7.79354 25.9023L6.60002 23.732L9.03354 24.1975L9.34205 21.7391L11.037 23.5472L12.7321 21.7391L13.0404 24.1975L15.474 23.732L14.2806 25.9024L16.5217 26.9565Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNauru);
export default __webpack_public_path__ + "static/media/nauru.ccdbb697d42ca4157990822391e4c756.svg";
export { ForwardRef as ReactComponent };